import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  toReducer
} from '../sliceFactory';

const createAssignGarantReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'assignGarant' });
  const withTable = injectTableSlice({ sliceBase: sliceBase });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createAssignGarantReducer;
